import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { ArrowLeft, Save, Sparkles } from "lucide-react";

export default function SeasonalBannerAdmin() {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/seasonal-banner")
      .then((response) => setMessage(response.data?.message || ""))
      .catch((error) => toast.error(error.response?.data?.detail || "Unable to load welcome banner"))
      .finally(() => setLoading(false));
  }, []);

  const save = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      const response = await api.put("/seasonal-banner", { message });
      setMessage(response.data?.message || "");
      toast.success(message.trim() ? "Welcome banner saved" : "Automatic seasonal message restored");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Unable to save welcome banner");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-3xl space-y-6" data-testid="seasonal-banner-admin-page">
      <div>
        <Button asChild variant="ghost" size="sm" className="mb-3 -ml-3">
          <Link to="/admin"><ArrowLeft className="mr-2 h-4 w-4" />Administration</Link>
        </Button>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary flex items-center gap-2">
          <Sparkles className="h-4 w-4" /> Admin Control
        </p>
        <h1 className="mt-1 font-display text-3xl font-extrabold">Seasonal welcome banner</h1>
      </div>

      <form onSubmit={save} className="space-y-4 border-t-4 border-sky-500 pt-4">
        <div className="space-y-2">
          <Label htmlFor="seasonal-banner-message">Banner message</Label>
          <Textarea
            id="seasonal-banner-message"
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            maxLength={200}
            rows={3}
            disabled={loading || saving}
            data-testid="seasonal-banner-message-input"
          />
          <p className="text-xs text-muted-foreground">Leave blank to restore the automatic calendar message. Maximum 200 characters.</p>
          <p className="text-right text-xs text-muted-foreground">{message.length}/200</p>
        </div>
        <Button type="submit" disabled={loading || saving} data-testid="save-seasonal-banner-button">
          <Save className="mr-2 h-4 w-4" />{saving ? "Saving…" : "Save message"}
        </Button>
      </form>
    </div>
  );
}